import { jsxs as u, jsx as p } from "react/jsx-runtime";
import { useXenditStore as D } from "../../store/index.mjs";
import { PersonIcon as P } from "@systemeio/ui/icons";
import { useTranslation as M, FormInput as s } from "@systemeio/ui";
import { useState as O, useEffect as w } from "react";
import F from "../../node_modules/react-payment-inputs/es/usePaymentInputs.mjs";
import "../../node_modules/react-payment-inputs/es/PaymentInputsWrapper.mjs";
import T from "../../node_modules/react-payment-inputs/es/images/index.mjs";
import { useDesignContext as V } from "../../providers/use-design-provider.mjs";
function X() {
  const { t: e } = M(), [d, m] = O(!1), {
    setCardNumber: _,
    setExpiryMonth: h,
    setExpiryYear: g,
    setCvc: y,
    setFormInvalid: l,
    cardHolderName: t,
    setCardHolderName: C
  } = D(), { meta: r, getCardImageProps: f, getCardNumberProps: b, getExpiryDateProps: x, getCVCProps: v } = F({
    errorMessages: {
      dateOutOfRange: e("public_pages_purchase.payment_inputs.date_out_of_range"),
      emptyCVC: e("public_pages_purchase.payment_inputs.empty_cvc"),
      invalidCVC: e("public_pages_purchase.payment_inputs.invalid_cvc"),
      emptyCardNumber: e("public_pages_purchase.payment_inputs.empty_card_number"),
      invalidCardNumber: e("public_pages_purchase.payment_inputs.invalid_card_number"),
      emptyExpiryDate: e("public_pages_purchase.payment_inputs.empty_expiry_date"),
      invalidExpiryDate: e("public_pages_purchase.payment_inputs.invalid_expiry_date"),
      monthOutOfRange: e("public_pages_purchase.payment_inputs.month_out_of_range"),
      yearOutOfRange: e("public_pages_purchase.payment_inputs.year_out_of_range")
    }
  }), n = t === "", i = d && n;
  w(() => {
    const a = t.match(/^[a-zA-Z]+ [a-zA-Z]+$/);
    l(!!r.error || n || !a);
  }, [t, i, n, r.error, l]);
  const N = (a) => {
    _(a.target.value.replace(/\s/g, ""));
  }, E = (a) => {
    const [o, c] = a.target.value.replace(/\s/g, "").split("/");
    o && c && o.length === 2 && c.length === 2 && (h(o), g(c));
  }, H = (a) => {
    y(a.target.value);
  }, {
    state: { primaryColor: I }
  } = V();
  return /* @__PURE__ */ u("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ u("div", { className: "flex flex-wrap gap-3", children: [
      /* @__PURE__ */ p(
        s,
        {
          ...b({ onChange: N }),
          addonBefore: /* @__PURE__ */ p("svg", { ...f({ images: T }) }),
          placeholder: e("public_pages_purchase.payment_inputs.card_number_placeholder"),
          inputClassName: "focus:!border-THEME-primary",
          error: r.touchedInputs.cardNumber ? r.erroredInputs.cardNumber : ""
        }
      ),
      /* @__PURE__ */ p(
        s,
        {
          ...x({ onChange: E }),
          placeholder: e("public_pages_purchase.payment_inputs.expiry_data_placeholder"),
          error: r.touchedInputs.expiryDate ? r.erroredInputs.expiryDate : "",
          inputClassName: "focus:!border-THEME-primary",
          className: "w-24"
        }
      )
    ] }),
    /* @__PURE__ */ u("div", { className: "flex flex-wrap gap-3", children: [
      /* @__PURE__ */ p(
        s,
        {
          addonBefore: /* @__PURE__ */ p(P, { height: 14, width: 21, fill: I }),
          type: "text",
          autoComplete: "cc-name",
          id: "cardName",
          name: "cardName",
          spellCheck: "false",
          "aria-label": e("public_pages_purchase.payment_inputs.card_holder_placeholder"),
          value: t,
          inputClassName: "focus:!border-THEME-primary",
          onChange: (a) => C(a.target.value),
          placeholder: e("public_pages_purchase.payment_inputs.card_holder_placeholder"),
          onBlur: () => m(!0),
          error: i ? e("public_pages_purchase.payment_inputs.empty_card_holder") : ""
        }
      ),
      /* @__PURE__ */ p(
        s,
        {
          ...v({ onChange: H }),
          placeholder: e("public_pages_purchase.payment_inputs.cvc_placeholder"),
          error: r.touchedInputs.cvc ? r.erroredInputs.cvc : "",
          inputClassName: "focus:!border-THEME-primary",
          className: "w-24"
        }
      )
    ] })
  ] });
}
export {
  X as default
};
